import { render, staticRenderFns } from "./InventoryItem.vue?vue&type=template&id=07e3d75f&scoped=true&"
import script from "./InventoryItem.vue?vue&type=script&lang=js&"
export * from "./InventoryItem.vue?vue&type=script&lang=js&"
import style0 from "./InventoryItem.vue?vue&type=style&index=0&id=07e3d75f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e3d75f",
  null
  
)

export default component.exports